"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var antd_1 = require("antd");
var TableMenuIsDeprecated_1 = require("../../../../../../shared/components/table_menus/TableMenuIsDeprecated");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var CfgCssClassList = /** @class */ (function (_super) {
    __extends(CfgCssClassList, _super);
    function CfgCssClassList(props) {
        return _super.call(this, props) || this;
    }
    CfgCssClassList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0
        }, function () {
            _this.props.data.LoadData();
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    CfgCssClassList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    CfgCssClassList.prototype.getColumns = function () {
        var _this = this;
        return [
            {
                title: this.props.lang.list.rows.class_name,
                dataIndex: this.props.data.dk_css_class_name,
                key: this.props.data.dk_css_class_name,
                width: 200
            }, {
                title: this.props.lang.list.rows.class_type,
                dataIndex: this.props.data.dk_css_type_title,
                key: this.props.data.dk_css_type_title,
                width: 200,
            }, {
                title: this.props.lang.list.rows.is_actual.title,
                dataIndex: this.props.data.dk_is_deprecated,
                key: this.props.data.dk_is_deprecated,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDeprecated_1.default, { deprecatedTexts: {
                            menu: _this.props.lang.list.rows.is_actual.menu.deprecate.menu,
                            text: _this.props.lang.list.rows.is_actual.menu.deprecate.text
                        }, notDeprecatedTexts: {
                            menu: _this.props.lang.list.rows.is_actual.menu.actual.menu,
                            text: _this.props.lang.list.rows.is_actual.menu.actual.text
                        }, record: {
                            key: record.key,
                            title: record.css_class_name,
                            deprecated: record.is_deprecated
                        }, onDeprecateClick: _this.doDeprecateAction.bind(_this) }));
                },
                filters: [
                    { text: this.props.lang.list.rows.is_actual.filter.deprecate, value: 'true' },
                    { text: this.props.lang.list.rows.is_actual.filter.actual, value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_deprecated === (value === 'true'); },
                sorter: function (a, b) { return _this.bool2Int(a.is_deprecated) - _this.bool2Int(b.is_deprecated); },
                width: 200,
            }, {
                title: this.props.lang.list.rows.date_added,
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: this.props.lang.list.rows.date_changed,
                dataIndex: this.props.data.dk_date_changed,
                key: this.props.data.dk_date_changed,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_changed.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: this.props.lang.list.rows.action.title,
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: _this.props.lang.list.rows.action.edit, onClick: function () {
                            _this.onEditCssClassClick(record);
                        } }),
                    React.createElement(TableActionDelete_1.default, { hint: _this.props.lang.list.rows.action.delete.hint, confirmText: _this.props.lang.list.rows.action.delete.confirm, onClick: function () {
                            _this.onDeleteClick(record);
                        } }))); },
                width: 100
            }
        ];
    };
    CfgCssClassList.prototype.onEditCssClassClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    CfgCssClassList.prototype.onDeleteClick = function (record) {
        var _this = this;
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotificationText(UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.message.css_class_deleted_fmt, [record.css_class_name]));
        });
    };
    CfgCssClassList.prototype.bool2Int = function (val) {
        if (val) {
            return 1;
        }
        else {
            return 0;
        }
    };
    CfgCssClassList.prototype.doDeprecateAction = function (key, title, deprecate) {
        var _this = this;
        this.props.data.DoSetIsDeprecated(key, deprecate, function () {
            if (deprecate) {
                notificationHelper_1.default.ShowTopRightNotificationText(UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.message.set_as_deprecated_fmt, [title]));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotificationText(UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.message.set_as_actual_fmt, [title]));
            }
        });
    };
    CfgCssClassList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    CfgCssClassList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.props.data.LoadData(function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.props.lang.list.message.css_class_loaded);
            });
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    CfgCssClassList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: {
                    create: this.props.lang.list.toolbars.hints.create,
                    refresh: this.props.lang.list.toolbars.hints.refresh
                }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return (React.createElement("div", null, UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.footer.title_fmt, [data.length.toString()])));
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, _this.props.lang.list.details.created),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, _this.props.lang.list.details.changed),
                            " [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                }, scroll: { x: true } })));
    };
    return CfgCssClassList;
}(React.Component));
exports.default = CfgCssClassList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_css_class/ui/component/CfgCssClassList.tsx
// module id = 2359
// module chunks = 0